import {
  MerchantSetupProductSchema,
  MerchantSetupProgressSchema,
} from "@redotech/redo-onboarding-db-schema";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

/**
 * Team-scoped dismiss. Hides the widget for everyone on this team.
 * Different from the per-device close behavior (which lives in
 * localStorage on the client).
 */
export const dismissMerchantSetupGuide = {
  name: "dismissMerchantSetupGuide" as const,
  input: z.object({ product: MerchantSetupProductSchema }),
  output: zExt.filterToValid(MerchantSetupProgressSchema),
};
